export const SettingsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33203 8.58631V7.41297C1.33203 6.71964 1.8987 6.14631 2.5987 6.14631C3.80537 6.14631 4.2987 5.29297 3.69203 4.2463C3.34537 3.6463 3.55203 2.8663 4.1587 2.51963L5.31204 1.85963C5.8387 1.5463 6.51871 1.73297 6.83204 2.25963L6.90537 2.3863C7.50537 3.43297 8.49204 3.43297 9.09871 2.3863L9.17204 2.25963C9.48538 1.73297 10.1654 1.5463 10.692 1.85963L11.8454 2.51963C12.452 2.8663 12.6587 3.6463 12.312 4.2463C11.7054 5.29297 12.1987 6.14631 13.4054 6.14631C14.0987 6.14631 14.6721 6.71297 14.6721 7.41297V8.58631C14.6721 9.27964 14.1054 9.85298 13.4054 9.85298C12.1987 9.85298 11.7054 10.7063 12.312 11.753C12.6587 12.3596 12.452 13.133 11.8454 13.4797L10.692 14.1397C10.1654 14.453 9.48538 14.2663 9.17204 13.7397L9.09871 13.613C8.49871 12.5663 7.51204 12.5663 6.90537 13.613L6.83204 13.7397C6.51871 14.2663 5.8387 14.453 5.31204 14.1397L4.1587 13.4797C3.55203 13.133 3.34537 12.353 3.69203 11.753C4.2987 10.7063 3.80537 9.85298 2.5987 9.85298C1.8987 9.85298 1.33203 9.27964 1.33203 8.58631Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
